import React from "react";
import "../styles/Header.css";



function Header() {
  return (
    <header className="header">
      <h1>Welcome</h1>
      <h3>Employee Directory</h3>
    </header>
  );
}

export default Header;
